module.exports = __webpack_public_path__ + "img/gl.0cf6198d.png";